import React, {FC, useState, useEffect, useRef} from "react";
import {observer} from "mobx-react-lite";
import * as PIXI from "pixi.js";
import {Sprite} from "@pixi/react";
import {LuckyStore} from "../model/LuckyStore";
import {LUCKY_LAYOUT} from "@/entities/lucky/model/luckyLayout";


interface LuckyCanvasProps {
    store: LuckyStore;
}

const easeOutCubic = (t: number) => 1 - Math.pow(1 - t, 3);

export const LuckyCanvas: FC<LuckyCanvasProps> = observer(({store}) => {
    const [app] = useState(() => new PIXI.Application());

    let animateId: number;

    // refs на спрайты
    const spriteRefs = useRef<Record<string, React.RefObject<PIXI.Sprite | null>>>(
        Object.fromEntries(
            store.sprites.map((sprite) => [
                sprite.name,
                React.createRef<PIXI.Sprite>(),
            ])
        )
    );

    useEffect(() => {
        if (!store.isSpinning) return;
        const ticker = PIXI.Ticker.shared;
        const tickHandler = () => {
            if (spriteRefs.current['wheel'].current) {
                spriteRefs.current['wheel'].current.rotation += 0.3;
            }
        }
        ticker.add(tickHandler);

        return () => {
            ticker.remove(tickHandler);
        };
    }, [store.isSpinning]);


    useEffect(() => {
        if (store.serverWinner < 0) return;

        const wheel = spriteRefs.current['wheel'].current;
        if (wheel == null) return;


        const startAngle = wheel.rotation;
        const anglePerSector = 360 / LUCKY_LAYOUT.sectorsCount;
        const targetAngle = 360 * 5 + (LUCKY_LAYOUT.sectorsCount - store.serverWinner) * anglePerSector;

        const start = performance.now();
        const duration = 5000;

        function animate(now: number) {
            if (wheel == null) return;

            const elapsed = now - start;
            const t = Math.min(elapsed / duration, 1);
            const eased = easeOutCubic(t);

            const currentAngle = startAngle + (targetAngle - startAngle) * eased;
            if (wheel.rotation != null)
                wheel.rotation = (currentAngle * Math.PI) / 180;

            if (t < 1) {
                animateId = requestAnimationFrame(animate);
            } else {
                store.stopSpin();
            }
        }

        animateId = requestAnimationFrame(animate);
        return () => {
            if (animateId) {
                cancelAnimationFrame(animateId);
                // store.stopSpin();
            }
        };

    }, [store.serverWinner]);


    return (
        <>
            {store.sprites.map((sprite) => (
                <Sprite
                    key={sprite.name}
                    ref={spriteRefs.current[sprite.name]}
                    image={sprite.image}
                    x={sprite.x}
                    y={sprite.y}
                    width={sprite.width}
                    height={sprite.height}
                    anchor={sprite.anchor}
                />
            ))}

        </>
    );
});
